// Výběr příslušenství pro řádek „Hodí se k tomu" pod položkou košíku —
// čisté funkce, žádný DOM (rozhodnutí Tomáše 2026-09-21, náhrada doplňku
// „Upsell a cross sell"; plán §Fáze 1).
//
// Zdrojem kandidátů je serverový panel souvisejících (`tr.related.related-to-…`),
// takže cena odpovídá ceníku přihlášeného zákazníka (VO sedí samo), nevzniká
// CLS a nic nezávisí na vyhledávacím API. DOM vrstva (`cartCrossSell.js`)
// kandidáty jen vytáhne a předá sem jako prostá data.
//
// ⛔ Cenový strop je POVINNÝ. Shoptet má zapnuté obousměrné párování
// („Párovat obousměrně"), takže v souvisejících příslušenství visí i výrobky,
// ke kterým bylo připnuté: detail nože C-NOZE za 179 Kč nese na ostré 4 kalová
// čerpadla za 1 399–2 490 Kč (sonda fáze 0, §0.2). Bez stropu by košík
// s nožem nabízel čerpadlo jako „příslušenství".

import L from '../locale/cs/cartCrossSellModel.js';

/** Dostupnost z nativního textu karty — bere jen jasné „Skladem …". */
export function isInStock(text) {
  return L.inStockRe.test(String(text || '').trim());
}

/**
 * Podpis plánu — mění se jen s obsahem (klíč položky → vybrané priceId).
 * Beze změny podpisu se řádky nepřekreslují, takže klik ani fokus nezmizí
 * při každém AJAX přepočtu košíku.
 */
export function planSignature(plan) {
  return (plan || [])
    .map(function (row) {
      return (
        row.key +
        ':' +
        row.picks
          .map(function (p) {
            return p.priceId;
          })
          .join(',')
      );
    })
    .join('|');
}

/**
 * Z položek košíku vybere, co se pod kterou nabídne.
 *
 * `items`: `[{ key, sku, unitPrice, candidates: [{ priceId, price, stock, … }] }]`
 * v pořadí, jak leží v košíku. `key` je `priceId` položky (v košíku unikátní),
 * `stock` je nativní text dostupnosti karty.
 *
 * Pravidla:
 *   • kandidát musí mít `priceId` (variantní karta formulář ani priceId nemá),
 *     dostupnost „Skladem…" a konečnou cenu ≤ jednotkové ceně položky;
 *   • kandidát už v košíku se vynechá (`inCart`);
 *   • jeden kandidát se ukáže nejvýš u jedné položky (globální dedup) —
 *     projíždí se od NEJDRAŽŠÍ položky, u té má příslušenství největší smysl;
 *   • `perItem` kusů pod položkou, `perCart` řádků na celý košík;
 *   • pořadí kandidátů určuje Shoptet (ruční piny jsou v Souvisejících první),
 *     model ho nemění.
 *
 * Vrací pole ve VSTUPNÍM pořadí položek, jen s neprázdným výběrem.
 */
export function pickCrossSell(items, inCart, opts) {
  const perItem = (opts && opts.perItem) || 2;
  const perCart = (opts && opts.perCart) || 3;
  const used = new Set(inCart || []);
  const picked = new Map();
  let rows = 0;

  const byPrice = (items || []).slice().sort(function (a, b) {
    return (b.unitPrice || 0) - (a.unitPrice || 0);
  });

  for (const item of byPrice) {
    if (rows >= perCart) break;
    const unit = Number(item.unitPrice);
    if (!isFinite(unit)) continue;
    const picks = [];
    for (const cand of item.candidates || []) {
      if (picks.length >= perItem) break;
      const price = Number(cand.price);
      if (!cand.priceId || !isFinite(price) || price <= 0) continue;
      if (!isInStock(cand.stock)) continue;
      if (price > unit) continue;
      if (used.has(cand.priceId)) continue;
      used.add(cand.priceId);
      picks.push(cand);
    }
    if (!picks.length) continue;
    picked.set(item.key, picks);
    rows += 1;
  }

  const out = [];
  for (const item of items || []) {
    const picks = picked.get(item.key);
    if (picks) out.push({ key: item.key, sku: item.sku, picks: picks });
  }
  return out;
}
